import { motion } from "framer-motion";
import { Gift, FileText, HelpCircle, ArrowRight, CheckCircle } from "lucide-react";

/* BonusSection — Bônus inclusos (cartilhas + quiz) */
const bonuses = [
  {
    icon: FileText,
    emoji: "📄",
    title: "4 Cartilhas Clínicas Exclusivas",
    description:
      "Materiais em PDF criados para consulta rápida sobre náuseas, mucosite, neutropenia febril e cuidados com cateter. Baixe e use no plantão.",
    value: "R$ 97,00",
    badge: "BÔNUS #1",
  },
  {
    icon: HelpCircle,
    emoji: "🧠",
    title: "95+ Questões de Quiz Clínico",
    description:
      "Quiz interativo para fixar o aprendizado e testar seus conhecimentos em oncologia. Ideal para residência e concursos.",
    value: "R$ 67,00",
    badge: "BÔNUS #2",
  },
];

export function BonusSection() {
  return (
    <section className="py-16 sm:py-24 bg-background relative overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,_var(--tw-gradient-stops))] from-accent/10 via-transparent to-transparent pointer-events-none" />

      <div className="container max-w-4xl mx-auto px-4 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-10 sm:mb-14"
        >
          <div className="inline-flex items-center gap-2 bg-accent/10 border border-accent/20 text-accent text-xs font-bold px-4 py-2 rounded-full mb-4">
            <Gift className="w-3.5 h-3.5" />
            Você também leva esses bônus sem pagar nada a mais
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4">
            E tem mais...
          </h2>
          <p className="text-muted-foreground text-sm sm:text-base max-w-xl mx-auto">
            Ao garantir seu acesso, você recebe esses bônus exclusivos como presente.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 sm:gap-6 mb-8 sm:mb-10">
          {bonuses.map((bonus, index) => {
            const Icon = bonus.icon;
            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                whileHover={{ y: -6, scale: 1.02 }}
                className="bg-card border-2 border-accent/20 rounded-3xl p-6 sm:p-7 relative overflow-hidden"
              >
                <div className="absolute top-3 right-3 bg-accent text-accent-foreground text-xs font-bold px-2 py-0.5 rounded-full">
                  {bonus.badge}
                </div>

                <span className="text-4xl sm:text-5xl mb-4 block">{bonus.emoji}</span>
                <h3 className="font-extrabold text-foreground text-base sm:text-xl mb-2">{bonus.title}</h3>
                <p className="text-muted-foreground text-xs sm:text-sm leading-relaxed mb-5">
                  {bonus.description}
                </p>

                <div className="flex items-center justify-between pt-4 border-t border-border">
                  <span className="text-muted-foreground text-xs">Valor individual:</span>
                  <span className="text-accent font-bold font-mono text-sm">{bonus.value}</span>
                </div>
              </motion.div>
            );
          })}
        </div>

        {/* Bloco de reforço + CTA */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="bg-card border-2 border-accent/30 rounded-3xl p-6 sm:p-8 text-center"
        >
          <CheckCircle className="w-10 h-10 sm:w-12 sm:h-12 text-accent mx-auto mb-4" />
          <h3 className="text-xl sm:text-2xl font-bold text-foreground mb-3">
            Tudo isso por apenas <span className="text-accent font-mono">R$ 77,90</span>
          </h3>
          <p className="text-muted-foreground text-xs sm:text-sm mb-6">
            Plataforma completa + 4 cartilhas + 95+ quizzes. Acesso imediato, garantia de 7 dias.
          </p>
          <motion.a
            href="https://pay.kiwify.com.br/bGcYJms"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 sm:gap-3 bg-accent hover:bg-accent/90 text-accent-foreground font-extrabold text-base sm:text-lg px-8 sm:px-10 py-4 rounded-2xl cursor-pointer w-full sm:w-auto justify-center"
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.97 }}
            animate={{
              boxShadow: [
                "0px 0px 0px 0px rgba(104,211,145,0)",
                "0px 0px 28px 6px rgba(104,211,145,0.35)",
                "0px 0px 0px 0px rgba(104,211,145,0)",
              ],
            }}
            transition={{ boxShadow: { repeat: Infinity, duration: 2.2 } }}
          >
            QUERO TUDO ISSO AGORA
            <ArrowRight className="w-5 h-5" />
          </motion.a>
        </motion.div>
      </div>
    </section>
  );
}
